import React, { memo, useState, lazy, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import logo from 'assets/images/logo-yellow.png';
import Button from 'components/button';
import Wrapper, {
  Copyright,
  Col3,
  Col12,
  Newsletter,
  Slogan,
  Flex,
  NavLink,
  NavItem,
  Info,
  Links,
  FooterLogo
} from './elements';
import Container from 'components/container';
import { SENDGRID_KEY } from 'constants.js';
import { useStateValue } from 'context/store';
import { setTermsTab } from 'context/tabs/actions';
import { scrollToTop } from 'utils/browserUtil';
import { useWindowSize, useOnClickOutside } from 'utils/hooks';

export const FooterToggle = lazy(() =>
  import(
    /* webpackChunkName: "FooterToggle" */ 'components/footer/footerToggle.js'
  )
);

function Footer(props) {
  const [email, setEmail] = useState('');
  const [isSubscribing, setSubscribing] = useState(false);
  const [isSubscribed, setSubscribed] = useState(false);
  const [isError, setError] = useState(false);
  const [toggle, setToggle] = useState(false);
  const ref = useRef();

  const { dispatch } = useStateValue();
  const { width } = useWindowSize();

  // function setTicketTab() {
  //   if (props.location.pathname !== '/') {
  //     props.history.push('/');
  //     window.scrollTo({ top: 626, behavior: 'smooth' });
  //   } else {
  //     window.scrollTo({ top: 626, behavior: 'smooth' });
  //   }
  //   dispatch(setTab(1));
  // }

  // function setMusicTab() {
  //   if (props.location.pathname !== '/') {
  //     props.history.push('/');
  //     window.scrollTo({ top: 626, behavior: 'smooth' });
  //   } else {
  //     window.scrollTo({ top: 626, behavior: 'smooth' });
  //   }
  //   dispatch(setTab(2));
  // }

  function setPolicyTab() {
    if (props.location.pathname !== '/terms') {
      props.history.push('/terms');
    } else {
      scrollToTop();
    }
    dispatch(setTermsTab(2));
  }

  function setTermsConditionsTab() {
    if (props.location.pathname !== '/terms') {
      props.history.push('/terms');
    } else {
      scrollToTop();
    }
    dispatch(setTermsTab(0));
  }

  const handleSubmit = e => {
    e.preventDefault();
    setSubscribing(true);

    axios
      .post(
        'https://api.sendgrid.com/v3/contactdb/recipients',
        JSON.stringify([{ email }]),
        {
          headers: {
            Authorization: `Bearer ${SENDGRID_KEY}`,
            'content-type': 'application/json'
          }
        }
      )
      .then(() => {
        setSubscribed(true);
        setSubscribing(false);
        setEmail('');
      })
      .catch(error => {
        setError(true);
        setSubscribing(false);
        console.error(error);
      });
  };

  const handleToggleFooter = () => setToggle(!toggle);
  useOnClickOutside(ref, () => setToggle(false));

  return (
    <div ref={ref}>
      {width >= 1024 && (
        <FooterToggle toggle={toggle} handleToggle={handleToggleFooter} />
      )}
      <Wrapper
        style={
          width >= 1024 && !toggle ? { display: 'none' } : { display: 'block' }
        }
      >
        <Container>
          <Flex>
            <Info>
              <FooterLogo src={logo} alt="logo" />
              <Slogan>
                <p>Making</p>
                <p>Commerce</p>
                <p>Social.</p>
              </Slogan>
              <Newsletter>
                <form onSubmit={handleSubmit}>
                  <label htmlFor="subscribeEmail">
                    Receive our newsletter:
                  </label>
                  <input
                    type="email"
                    placeholder="E-mail Address"
                    required="required"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    id="subscribeEmail"
                  />
                  <Button
                    className="bg-dark"
                    color={
                      isSubscribing
                        ? 'white'
                        : isError
                        ? 'danger'
                        : isSubscribed
                        ? 'success'
                        : 'white'
                    }
                    style={{
                      width: '100%'
                    }}
                  >
                    {isSubscribing ? (
                      'Subscribing...'
                    ) : isError ? (
                      <>Something went wrong &#x2715;</>
                    ) : isSubscribed ? (
                      <>Subcribed &#x2713;</>
                    ) : (
                      'Subscribe'
                    )}
                  </Button>
                </form>
              </Newsletter>
            </Info>
            <Links>
              <Col3 style={{ minWidth: '230px' }}>
                <span>ABOUT US</span>
                <ul className="navbar-nav">
                  <NavItem>
                    <NavLink href="mailto:hello@mookh.africa">
                      Customer Support
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <button
                      name="ticketFooterButton"
                      onClick={setTermsConditionsTab}
                    >
                      Terms and Conditions
                    </button>
                  </NavItem>
                  <NavItem>
                    <button name="ticketFooterButton" onClick={setPolicyTab}>
                      Privacy and Cookie Policy
                      {/* <br style={width > 576 ? {display:'none'} : {display: 'block'}}/> */}
                    </button>
                  </NavItem>
                  {/* <NavItem>
                  <NavLink href="/faq">FAQs</NavLink>
                </NavItem> */}
                </ul>
              </Col3>
              <Col3>
                <span>COMMUNITY</span>
                <ul className="navbar-nav">
                  <NavItem>
                    <NavLink
                      href="https://mag.mookh.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Magazine
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.instagram.com/mookh.africa"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.facebook.com/mookh.africa/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://twitter.com/MOOKHAFRICA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Twitter
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.youtube.com/channel/UC4HnV_ySVL-44sbn8ZjT-2Q"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      YouTube
                    </NavLink>
                  </NavItem>
                </ul>
              </Col3>
              <Col3>
                <span>WHATSAPP US</span>
                <ul className="navbar-nav">
                  <NavItem>Email: hello@mookh.africa</NavItem>
                  <NavItem>ke: +254 798 984828</NavItem>
                  <NavItem>ug: +256 776 836 944</NavItem>
                </ul>
              </Col3>
              <Col12>
                <Copyright>
                  © {new Date().getFullYear()} Mookh Africa Ltd.
                </Copyright>
              </Col12>
            </Links>
          </Flex>
        </Container>
      </Wrapper>
    </div>
  );
}

export default memo(withRouter(Footer));
